export default __webpack_public_path__ + "ui/assets/img/arrow-right-32.svg";